var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./AwardsADGContent.jinja');
require('./AwardsADGContent.less');

var AdvertisingBanner = require('front/components/AdvertisingBanner/AdvertisingBanner');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AdvertisingBanner': {selector: '.AdvertisingBanner', viewConstructor: AdvertisingBanner}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsADGContent/AwardsADGContent.js
// module id = 160
// module chunks = 0